// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__mPjqd","total":"Cart_total__-59BR","totalAmount":"Cart_totalAmount__kT86S","actions":"Cart_actions__90V4D","button":"Cart_button__ZXbjT"};